module.exports = __webpack_public_path__ + "static/media/program_category_black_fade3.72b80df6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/program_category_black_fade3.png
// module id = 609
// module chunks = 0